import Env from "../Env";
import CsConstant from "../CsConstant";
import LegalAppBridge from "../LegalAppBridge";
import * as Sentry from "@sentry/react";

class Request {
  static API_ROOT = Env.getBackendURL();
  static API_CONFIG = this.API_ROOT + 'config/';
  static API_COMPANY = this.API_CONFIG + 'company/';
  static API_PRIVACY = this.API_CONFIG + 'privacy/';
  static API_UPLOAD = this.API_ROOT + 'upload/';

  static API_COMPANY_LOAD = this.API_COMPANY + 'load';
  static API_PRIVACY_SAVE = this.API_PRIVACY + 'save';

  static API_UPLOAD_GET_TOKEN = this.API_UPLOAD + 'token';
  static API_UPLOAD_IMAGES_EDITORS = this.API_UPLOAD + 'editor_image'
  static API_UPLOAD_COOKIE_ICON = this.API_UPLOAD + 'cookie_icon';

  static load(url, handlerSuccess, handlerError, handlerComplete) {
    this.doRequest(url, 'GET', null, handlerSuccess, handlerError, handlerComplete)
  }

  static submit(url, data, handlerSuccess, handlerError, handlerComplete) {
    this.doRequest(url, 'POST', data, handlerSuccess, handlerError, handlerComplete);
  }

  static doRequest(url, method, data, handlerSuccess, handlerError, handlerComplete) {
    let request = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        [CsConstant.HEADER_STORE_NAME]: LegalAppBridge.getStoreName(),
        [CsConstant.HEADER_HASHED_STORE]: LegalAppBridge.getCsToken(),
      }
    };
    // Get request cannot have body
    if ('POST' === method) {
      request['body'] = JSON.stringify(data);
    }

    this.fetch(url, request, handlerSuccess, handlerError, handlerComplete);
  }

  static fetch(url, request, handlerSuccess, handlerError, handlerComplete) {
    fetch(url, request)
      .then(response => response.json())
      .then(response => {
        Env.log('Request done', response);
        if (typeof handlerSuccess === 'function') {
          handlerSuccess(response);
        }
      })
      .catch(err => {
        Env.log('Request error', err);
        if (typeof handlerError === 'function') {
          handlerError(err);
        }
        Sentry.captureException(err);
      })
      .finally(() => {
        if (typeof handlerComplete === 'function') {
          handlerComplete();
        }
      });
  }

  static submitFiles(url, files, headers) {
    let formData = new FormData();
    for (let key in files) {
      if (files.hasOwnProperty(key)) {
        const fileData = files[key];

        if (fileData) {
          formData.append(key, fileData);
        }
      }
    }

    const request = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        ...headers,
      },
      body: formData
    };

    return this._fetchR(url, request);
  }

  static fetchUploadToken() {
    return Request.loadR(this.API_UPLOAD_GET_TOKEN);
  }

  /**
   * @param url
   * @returns {Promise<Response>}
   */
  static loadR(url) {
    return this._doRequestR(url, 'GET');
  }

  /**
   * @param url
   * @param data
   * @returns {Promise<Response>}
   */
  static submitR(url, data) {
    return this._doRequestR(url, 'POST', data);
  }

  /**
   *
   * @param url
   * @param method
   * @param data
   * @returns {Promise<Response>}
   */
  static _doRequestR(url, method, data) {
    let request = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        [CsConstant.HEADER_STORE_NAME]: LegalAppBridge.getStoreName(),
        [CsConstant.HEADER_HASHED_STORE]: LegalAppBridge.getCsToken(),
      }
    };
    // Get request cannot have body
    if ('POST' === method) {
      request['body'] = JSON.stringify(data);
    }

    return this._fetchR(url, request);
  }

  /**
   *
   * @param url
   * @param request
   * @returns {Promise<Response>}
   */
  static _fetchR(url, request) {
    return fetch(url, request).then(response => {
      Env.log('Request done', response);
      return response.json();
    });
  }

  static catchError(error) {
    Env.log('Request error', error);
    LegalAppBridge.toastError('Unknown error');
    Sentry.captureException(error);
  }
}

export default Request;
